import type { OnboardingState } from '#lib/steps/state';
import { ONBOARDING_STORAGE_KEY } from './storage-key';

/** Persist the onboarding state, ignoring storage that is unavailable. */
export const saveOnboardingState = (state: OnboardingState): void => {
  /* v8 ignore next 3 -- SSR guard: window is always defined under the happy-dom test runner */
  if (typeof window === 'undefined') {
    return;
  }
  try {
    window.sessionStorage.setItem(ONBOARDING_STORAGE_KEY, JSON.stringify(state));
  } catch {
    // sessionStorage may be unavailable (Safari private mode); ignore.
  }
};
